"use client";

import Link from "next/link";
import { use, useEffect, useState } from "react";

import { Button } from "@/components/ui/button";
import { Settings } from "@/payload-types";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";

export interface OrderButtonProps {
  slug: string;
}

export function OrderButton(props: {
  settings: Promise<Settings>;
  slug: string;
}) {
  "use client";

  const { tgOrdersReceiver, tgOrdersMessageTemplate, vkOrdersReceiver } = use(
    props.settings
  );

  const [tgOrderUrl, setOrderUrl] = useState(
    new URL(`https://t.me/${tgOrdersReceiver}`)
  );

  useEffect(() => {
    const url = new URL(`https://t.me/${tgOrdersReceiver}`);

    url.searchParams.set(
      "text",
      tgOrdersMessageTemplate.replace(
        "{link}",
        `${window.location.origin}/product/${props.slug}`
      )
    );

    setOrderUrl(url);
  }, [props.slug, tgOrdersMessageTemplate, tgOrdersReceiver]);

  return (
    <Drawer>
      <DrawerTrigger asChild>
        <Button
          size="lg"
          className="h-11 lg:h-13 lg:text-2xl lg:w-full font-light"
        >
          Заказать
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>Заказ зверенка</DrawerTitle>
          <DrawerDescription className="mb-1">
            Чтобы заказать зверенка свяжитесь с нами любым удобным способом. Мы
            учтем ваши пожелания, если необходимо подберем одежду и аксессуары,
            определим способ и стоимость доставки.
          </DrawerDescription>

          <div className="flex flex-col gap-3 text-lg">
            <div className="flex flex-col gap-1">
              <h2 className="text-2xl">Связаться через Telegram</h2>
              <Link href={tgOrderUrl}>
                <Button>Открыть Telegram</Button>
              </Link>
              <div className="text-foreground/80">
                Мы перенаправим вас в наш чат в Telegram.
              </div>
            </div>

            {vkOrdersReceiver && (
              <div className="flex flex-col gap-1">
                <h2 className="text-2xl">Связаться через VK</h2>
                <Link href={`https://vk.me/${vkOrdersReceiver}`}>
                  <Button>Открыть VK</Button>
                </Link>
                <div className="text-foreground/80">
                  Мы перенаправим вас в наш чат в VK.
                </div>
              </div>
            )}
          </div>
        </DrawerHeader>
      </DrawerContent>
    </Drawer>
  );
}
